{
  "page_count": "van {n, plural, one{# pagina} other{# pagina's}}"
}
